import {asyncLoad, asyncPost, asyncDelete} from '.';
import {formValidation, handleError, rowIndexFromPage, sortParam, objectToParams} from '../helpers';

export const getTeams = ({
  pageInfo = {},
  sortInfo = {},
}) => async dispatch => {
  const params = {
    pageSize: pageInfo.pageSize,
    rowIndex: rowIndexFromPage(pageInfo),
    sort: sortParam(sortInfo),
  };
  return await asyncLoad({
    dispatch,
    title: 'Teams',
    url: `/teams?${objectToParams(params)}`,
  });
};

export const saveTeam = team => async dispatch => {
  const formObject = formValidation.setupFormBody(team, false);
  let params = {};

  if (formObject.hasError) {
    handleError(formObject.errorMessage, null, dispatch);
    return null;
  }

  if (formObject.body.calendarStyle === '#ffffff') {
    handleError('White is not a valid color for a team.', null, dispatch);
    return null;
  }

  if (formObject.body.teamId) {
    params = {method: 'PUT'};
  }

  try {
    return await asyncPost({
      body: formObject.body,
      dispatch,
      params,
      successMessage: `The Team has been ${
        team.teamId ? 'updated' : 'added'
        } successfully.`,
      title: 'Team',
      url: `/teams${team.teamId ? `/${team.teamId.value}` : ''}`,
    });
  } catch (err) {
    return null;
  }
};

export const deleteTeam = teamId => dispatch =>
  asyncDelete({
    dispatch,
    successMessage: 'This Team has been deleted successfully.',
    title: 'Team',
    url: `/teams/${teamId}`,
  });



// WEBPACK FOOTER //
// ./src/actions/teamActions.js